import hasSomePlanByType from 'utils/pivot/plan/hasSomePlanByType'
import { EPIC } from 'core/constants/products'
import forEach from 'utils/DOM/forEach'
import isEpicPlan from 'utils/pivot/plan/isEpicPlan'

const setMichiganEpicPlanDisclaimer = (
  { hcStorage, plansByType, plans, planId },
  checkOnlySelectedPlan = true
) => {
  const isMichigan = hcStorage.location.state_acronym === 'MI'
  if (!isMichigan) return

  if (checkOnlySelectedPlan) {
    const plan = plans[planId]
    if (!isEpicPlan(plan)) return
  } else {
    const plansHaveEpic = hasSomePlanByType([EPIC], plansByType)
    if (!plansHaveEpic) return
  }

  forEach('.michigan-epic-plan-disclaimer', node => {
    node.classList.remove('d-none')
  })
}

export default setMichiganEpicPlanDisclaimer
